import { render, staticRenderFns } from "./ImportContactsTabs.vue?vue&type=template&id=0ee01f97&scoped=true&"
import script from "./ImportContactsTabs.vue?vue&type=script&lang=js&"
export * from "./ImportContactsTabs.vue?vue&type=script&lang=js&"
import style0 from "./ImportContactsTabs.vue?vue&type=style&index=0&id=0ee01f97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee01f97",
  null
  
)

export default component.exports